import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	methods: {
		loadAttivitaTipi() {
			let me = this;
			let pathResourceAttivitaTipi = "/gestioneattivitatipi";
			UtilityMixin.methods.loadDataResources(pathResourceAttivitaTipi, {}, me.loadAttivitaTipiSuccess, me.loadAttivitaTipiError);
		},
		loadAttivitaTipiSuccess(response) {
			let me = this;
			me.tipoAttivitaOptions = response.data.data.list;
		},
		loadAttivitaTipiError(error) {
			console.log(error);
		},
	},
};
